function normalizeText(text) {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}

export function calculateApneaRisk(params) {
  console.log("=== calculateApneaRisk started ===");
  console.log("Input params:", Object.fromEntries(params.entries()));
  
  try {
    let newStopBang = null;
    
    // Check if we have a direct stopbang decimal parameter
    if (params.has("sbd")) {
      console.log("Using direct stopbang decimal parameter");
      newStopBang = parseInt(params.get("sbd"), 10);
      console.log("Direct stopbang decimal:", newStopBang);
      
      if (newStopBang > 8 || newStopBang < 1) {
        throw new Error("Invalid stopbang decimal");
      }
    } else {
      console.log("Calculating from individual parameters");
      
      // Required parameters for calculation (updated for new parameter structure)
      const reqUserInput = ["w", "h", "a", "nB", "s", "md", "ss"];
      const missingUserInput = [];

      for (let param of reqUserInput) {
        if (!params.has(param)) {
          missingUserInput.push(param);
        }
      }

      if (missingUserInput.length > 0) {
        console.error("Missing parameters:", missingUserInput);
        throw new Error(`Missing required query parameters: ${missingUserInput.join(", ")}`);
      }

      console.log("All required parameters present");

      const userInput = {
        weight: parseInt(params.get("w"), 10),
        height: (parseInt(params.get("h"), 10) / 100), // Convert cm to m
        age: parseInt(params.get("a"), 10),
        isMale: normalizeText(params.get("s")) === "masculino",
        isNeckBig: parseInt(params.get("nB")) === 1,
        stopScore: parseFloat(params.get("ss")),
        medicId: params.get("md"), // Store medic identifier
      };

      console.log("Parsed user input:", userInput);

      // Calculate BMI and scores
      const bmi = userInput.weight / (userInput.height * userInput.height);
      console.log("Calculated BMI:", bmi);
      
      const scoreB = bmi > 35 ? 1 : 0;
      console.log("Score B (BMI > 35):", scoreB);
      
      const scoreA = userInput.age > 50 ? 1 : 0;
      console.log("Score A (Age > 50):", scoreA);
      
      // Simplified neck score based on nB parameter only
      let scoreN = userInput.isNeckBig;
      console.log("Score N (Neck big):", scoreN);
      
      const scoreG = userInput.isMale ? 1 : 0;
      console.log("Score G (Gender male):", scoreG);
      
      const scoreBang = scoreB + scoreA + scoreN + scoreG;
      console.log("Score BANG (B+A+N+G):", scoreBang);
      
      const scoreBng = scoreB + scoreN + scoreG;
      console.log("Score BNG (B+N+G):", scoreBng);
      
      const stopBang = scoreBang + userInput.stopScore;
      console.log("STOP BANG total (BANG + STOP):", stopBang);

      // Special rule: Values 3 and 4 of STOP BANG become 5 if STOP>=2 and BNG>=1
      newStopBang = Math.round(stopBang);
      console.log("Rounded STOP BANG:", newStopBang);
      
      if (stopBang >= 3 && stopBang <= 4 && userInput.stopScore >= 2 && scoreBng >= 1) {
        console.log("Applying special rule: STOP BANG 3-4 becomes 5");
        console.log("Conditions: stopBang >= 3 && stopBang <= 4 && stopScore >= 2 && scoreBng >= 1");
        console.log(`Values: ${stopBang} >= 3 && ${stopBang} <= 4 && ${userInput.stopScore} >= 2 && ${scoreBng} >= 1`);
        newStopBang = 5;
      }

      console.log("Final newStopBang:", newStopBang);

      console.log("newStopBangDecimal (1-8 scale):", newStopBang);
    }

    // Determine risk level and Spanish text based on 1-8 scale
    let apneaLikelihood = null;
    let riskNameSpanish = null;
    
    console.log("Determining risk level for newStopBang:", newStopBang);
    
    if (newStopBang >= 1 && newStopBang <= 2) {
      apneaLikelihood = "low";
      riskNameSpanish = "bajo";
    } else if (newStopBang >= 3 && newStopBang <= 4) {
      apneaLikelihood = "moderate";
      riskNameSpanish = "moderado";
    } else if (newStopBang >= 5 && newStopBang <= 8) {
      apneaLikelihood = "high";
      riskNameSpanish = "alto";
    }

    console.log("Risk assessment:", { apneaLikelihood, riskNameSpanish });

    const result = {
      success: true,
      level: newStopBang,
      apneaLikelihood,
      riskNameSpanish,
      medicId: params.has("md") ? params.get("md") : null, // Include medic ID in result
      error: null
    };

    console.log("=== calculateApneaRisk completed successfully ===");
    console.log("Final result:", result);
    
    return result;

  } catch (exception) {
    console.error("=== Risk calculation error ===");
    console.error("Exception:", exception);
    console.error("Exception message:", exception.message);
    
    const errorResult = {
      success: false,
      level: 8, // Default fallback
      apneaLikelihood: "high",
      riskNameSpanish: "alto",
      medicId: params.has("md") ? params.get("md") : null,
      error: exception.message
    };
    
    console.log("Error result:", errorResult);
    console.log("=== calculateApneaRisk completed with error ===");
    
    return errorResult;
  }
}

export function parseUrlParameters() {
  return new URLSearchParams(window.location.search);
} 